import { Controller } from '@hotwired/stimulus'

// Email opcional en los resultados del simulador de préstamos. Envía el formulario sin
// salir de la página y sustituye el bloque por lo que devuelve el servidor: la confirmación,
// o el mismo formulario con el error (422) o con el aviso del límite de envíos (429).
//
// Cualquier otra respuesta (token caducado, error del servidor) es una página entera que no
// se puede meter dentro de los resultados: se deja el formulario y se avisa.
//
// Los diálogos del aviso legal y de la política de privacidad se abren con un <script> en
// línea, y un <script> insertado con HTML no se ejecuta: hay que volver a crearlo, como hace
// `multistep-wizard` con los resultados.
const RESPUESTAS_DEL_BLOQUE = [200, 422, 429]

export default class extends Controller {
  static targets = ['boton']

  async enviar (event) {
    event.preventDefault()
    const form = event.target
    this.botonTarget.disabled = true

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' }
      })
      if (!RESPUESTAS_DEL_BLOQUE.includes(response.status)) throw new Error(`HTTP ${response.status}`)

      this.sustituir(await response.text())
    } catch {
      this.avisarDelFallo(form)
    }
  }

  sustituir (html) {
    const plantilla = document.createElement('template')
    plantilla.innerHTML = html.trim()
    const bloque = plantilla.content.firstElementChild
    if (!bloque) throw new Error('Respuesta vacía')

    bloque.querySelectorAll('script').forEach(script => {
      const nuevo = document.createElement('script')
      nuevo.textContent = script.textContent
      script.replaceWith(nuevo)
    })
    this.element.replaceWith(bloque)
  }

  avisarDelFallo (form) {
    this.botonTarget.disabled = false
    if (form.querySelector('[data-fallo-envio]')) return

    const aviso = document.createElement('p')
    aviso.className = 'rnk-Flash-danger'
    aviso.setAttribute('role', 'alert')
    aviso.dataset.falloEnvio = ''
    aviso.textContent = 'No hemos podido enviar los resultados. Vuelve a hacer la simulación para recibirlos.'
    form.prepend(aviso)
  }
}
